import { render } from "./OrdersFlowCard.vue?vue&type=template&id=f1d27088&scoped=true"
import script from "./OrdersFlowCard.vue?vue&type=script&lang=js"
export * from "./OrdersFlowCard.vue?vue&type=script&lang=js"

import "./OrdersFlowCard.vue?vue&type=style&index=0&id=f1d27088&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d27088"]])

export default __exports__